import { Request, Response } from "express"

import { getPhotos } from "#services/recipe/photos"

export const getRecipePhotos = async (req: Request, res: Response) => {
	const list = await getPhotos({
		id: req.params.recipeID,
	})

	res.json(list)
}
